// intl-tel-input calls Object.hasOwn, which Safari before 15.4 and Chrome
// before 93 lack. The build target lowers syntax only and adds no API.
if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: function hasOwn(object: object, key: PropertyKey) {
      return Object.prototype.hasOwnProperty.call(object, key);
    },
    configurable: true,
    writable: true,
  });
}

export {};
